import React, { useEffect, useState } from "react";
import { NotificationIcon } from "../../../utility/constants/assetsManager";
import {
  colorDarkBlue,
  colorDarkGreen,
  colorDarkRed,
  colorDarkYellow,
  colorLightBlue,
  colorLightGreen,
  colorLightRed,
  colorLightYellow
} from "../../../utility/constants/colorManager";
import {
  ADMIN,
  ADMIN_USER,
  CLIENT,
  RESELLER,
  RUPEES_SYMBOL,
  STATUS_CODE_200
} from "../../../utility/constants/valueConstants";
import { CustomButton } from "../main_comps/custom_button";
import { HiArrowLeft } from "react-icons/hi";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { formatBalance } from "../../../utility/moneyFormatter";
import {
  checkAnyOneObjHasAllValue,
  checkObjHasAllValue
} from "./ComissionContainer";
import moment from "moment";
import secureStorage from "../../../services/secureStorage";
import {
  SS_INDUSTRY_TYPE,
  SS_INTERNAL,
  SS_ROLE
} from "../../../utility/constants/secureStorageManager";
import { ApiRequestPost } from "../../../data/network/services/ApiRequestPost";
import { ApiRequestGet } from "../../../data/network/services/ApiRequestGet";

const CountsContainer = ({ backgroundColor, color, title, count, style }) => {
  return (
    <div
      style={{
        backgroundColor,
        display: "flex",
        padding: "12px 20px",
        justifyContent: "space-evenly",
        alignItems: "center",
        borderRadius: 5,
        minWidth: 140,
        ...style
      }}
    >
      <p
        style={{
          color,
          marginRight: 20,
          fontWeight: "600",
          fontSize: 15
        }}
      >
        {title}
      </p>
      <p
        style={{
          color,
          fontWeight: "600",
          fontSize: 15
        }}
      >
        {RUPEES_SYMBOL} {formatBalance(Number(count))}
      </p>
    </div>
  );
};
function TopHeaderComponent({
  filterRequired = true,
  notificationRequired = true,
  backActionRequired = false,
  onClickFilter,
  headerTitle = "",
  customButtonRequired,
  dashboardFilterrequired = false,
  headerStyle
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [payoutAvailable, setPayoutAvailable] = useState(false);
  const [payinAvailable, setPayinAvailable] = useState(false);
  const [voucherAvailable, setVoucherAvailable] = useState(false);
  const [vanAvailable, setVanAvaliable] = useState(false);
  const role = secureStorage.getItem(SS_ROLE);
  const [reserveBalance, setReserveBalance] = useState({});
  const [industryType, setIndustryType] = useState("");

  const [clientData, setClientData] = useState("");
  const [balance, setBalance] = useState("");
  const [cashfreeClient, setCashfreeClient] = useState(false);
  const internal = secureStorage.getItem(SS_INTERNAL);

  const transactionVolumeCount = useSelector(
    (state) => state.dashboardCountSlice.mainTransactionVolume
  );
  const payinBalance = useSelector(
    (state) => state.dashboardCountSlice.clientBalance
  );
  const payoutBalance = useSelector(
    (state) => state.dashboardCountSlice.clientPayoutBalance
  );

  const resellerServiceData = useSelector(
    (state) => state.dropDownListSlice.serviceProviderList
  );

  const servicesArray = resellerServiceData.filter(
    (item) => item.type === "voucher"
  );

  const voucherBalance = useSelector(
    (state) => state.dashboardCountSlice.clientVoucherBalance
  );
  const clientSecret = useSelector((state) => state.listingSlice.clientDetails);
  const globalFilter = useSelector((state) => state.globalFiltersSlice);
  const cashfreeBalance = useSelector(
    (state) => state.listingSlice.addCashfreeBal
  );
  console.log(cashfreeBalance, "cashfreeBalance");

  const fetchClientReserves = () => {
    ApiRequestPost.fetchClientReserves({})
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setReserveBalance(res.data[0]);
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    let payout = clientSecret.filter((obj) => obj.serviceType === "payout");

    let payin = clientSecret.filter(
      (obj) => obj.serviceType === "payin" && obj.mechanism !== "coupon"
    );
    let voucher = clientSecret.filter((obj) => obj.serviceType === "voucher");

    let insideOfService = clientSecret.filter((obj) => obj.serviceType);

    let axisVan = clientSecret.filter(
      (obj) =>
        obj.serviceType.toUpperCase() === "VAN" &&
        (obj.serviceProviderName === "AXIS" ||
          obj.serviceProviderName === "IDFC")
    );

    // let cfClient = clientSecret.filter(
    //   (obj) =>
    //     obj.serviceType.toUpperCase() === "PAYOUT" &&
    //     obj.serviceProviderName === "CASHFREE"
    // );
    // if (cfClient) {
    //   setCashfreeClient(true);
    // }

    if (payin.length > 0) {
      setPayinAvailable(true);
    }
    if (voucher.length > 0) {
      setVoucherAvailable(true);
    }

    if (axisVan.length !== 0) {
      setVanAvaliable(true);
    } else setVanAvaliable(false);

    if (payout?.length !== 0) {
      setPayoutAvailable(true);
    } else setPayoutAvailable(false);
  }, [clientSecret]);

  useEffect(() => {
    if (role === CLIENT) {
      fetchClientReserves();
    }
  }, []);

  useEffect(() => {
    console.log(payoutAvailable, "payout");
  }, [payoutAvailable]);

  const getIndustryType = async () => {
    setIndustryType();
    const ind = await secureStorage.getItem(SS_INDUSTRY_TYPE);
    setIndustryType(ind?.toUpperCase());
  };
  const fetchZyroClientCurrentBalanceVan = () => {
    ApiRequestGet.fetchZyroClientCurrentBalanceVan({
      client_secret: clientData?.clientId,
      program_id: clientData?.program
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          setBalance(response?.data?.availableBal);
        }
      })
      .catch((error) => {});
  };

  useEffect(() => {
    if (role === CLIENT) {
      getIndustryType();
    }
  }, [role]);

  console.log(clientSecret, "CLIENT secret");

  useEffect(() => {
    if (clientData && role === CLIENT) {
      console.log("inside");
      fetchZyroClientCurrentBalanceVan();
    }
  }, [clientData]);

  useEffect(() => {
    if (role === CLIENT) {
      let payout = clientSecret.filter(
        (obj) =>
          obj?.serviceType?.toUpperCase() === "PAYOUT" &&
          obj.serviceProviderName?.toUpperCase() === "ZYRO" &&
          obj.mechanism === "van"
      );
      if (payout?.length !== 0) {
        setClientData(payout[0]);
      }
    }
  }, [clientSecret]);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flex: 1,
        justifyContent: "space-between",
        alignItems: "center"
      }}
    >
      <div style={{ display: "flex" }}>
        {backActionRequired && (
          <div
            style={{
              width: "28px",
              height: "28px",
              borderRadius: 4,
              backgroundColor: "#E5e5e5",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              marginRight: 15
            }}
            onClick={() => navigate(-1)}
          >
            <HiArrowLeft color="#38369C" size={12} />
          </div>
        )}
        <p
          style={{
            fontWeight: "500",
            fontSize: 16,
            color: "#1E2234",
            textTransform: "capitalize",
            ...headerStyle
          }}
        >
          {headerTitle}
        </p>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center"
        }}
      >
        {/* {(role === ADMIN || role === ADMIN_USER || payoutAvailable) && (
          <CountsContainer
            backgroundColor={colorLightBlue}
            color={colorDarkBlue}
            title="Prefund"
            count={
              transactionVolumeCount.totalPrefund
                ? transactionVolumeC1ount.totalPrefund
                : 0
            }
            style={{
              marginRight: 15,
              marginLeft: 15,
            }}
          />
        )} */}

        {/* {internal &&
          reserveBalance.rollbackReserves > 0 &&
          (industryType !== "CRYPTO" || industryType !== "CORPORATE") && (
            <CountsContainer
              backgroundColor={"rgba(56, 54, 156, 0.1)"}
              color={"#38369C"}
              title="Rolling Reserve"
              count={reserveBalance.rollbackReserves ?? 0}
              style={{
                marginRight: 15
              }}
            />
          )}

        {internal &&
          reserveBalance.security > 0 &&
          (industryType !== "CRYPTO" || industryType !== "CORPORATE") && (
            <CountsContainer
              backgroundColor={"#FFD596"}
              color={"#38369C"}
              title="Security Deposit"
              count={reserveBalance.security ?? 0}
              style={{
                marginRight: 15
              }}
            />
          )} */}

        {dashboardFilterrequired === false && (
          <>
            {((role !== CLIENT && internal) ||
              ((payinAvailable || vanAvailable) &&
                industryType !== "CRYPTO")) && (
              <CountsContainer
                backgroundColor={colorLightGreen}
                color={colorDarkGreen}
                title="Payin "
                count={payinBalance.count ?? 0}
                style={{
                  marginRight: 15
                }}
              />
            )}
            {/* Voucher */}
            {((role !== CLIENT && role !== RESELLER && internal) ||
              voucherAvailable ||
              (servicesArray.length > 0 && role === RESELLER)) && (
              <CountsContainer
                backgroundColor={colorLightYellow}
                color={colorDarkYellow}
                title="Voucher"
                count={voucherBalance.count ?? 0}
                style={{
                  marginRight: 15
                }}
              />
            )}
            {((role !== CLIENT && internal) ||
              (payoutAvailable && industryType !== "CRYPTO")) && (
              <CountsContainer
                backgroundColor={colorLightRed}
                color={colorDarkRed}
                title="Payout"
                count={
                  clientData?.serviceProviderName?.toUpperCase() === "ZYRO" &&
                  clientData?.mechanism === "van"
                    ? balance
                    : // : cashfreeClient
                      // ? cashfreeBalance ?? 0
                      payoutBalance.count ?? 0
                }
              />
            )}
          </>
        )}

        {notificationRequired && (
          <NotificationIcon
            style={{
              marginLeft: 20,
              marginRight: 10
            }}
          />
        )}
        {filterRequired && (
          <CustomButton
            styles={{
              marginLeft: 20,
              marginRight: 10,
              backgroundColor: "white",
              borderWidth: 1,
              borderColor: "#1E2234",
              padding: "12px 20px"
            }}
            title={"Filter"}
            textStyles={{
              color: "#1E2234"
            }}
            onClick={onClickFilter}
            showChecked={checkAnyOneObjHasAllValue({
              fromDate:
                globalFilter?.fromDate === "Invalid date" ||
                globalFilter?.fromDate === ""
                  ? ""
                  : globalFilter?.fromDate,
              clientId: globalFilter?.clientId?.value ?? "",
              resellerId: globalFilter?.resellerId?.value ?? "",
              resellerStatus: globalFilter?.resellerStatus ?? "",
              serviceProvider: globalFilter?.serviceProvider?.value ?? "",
              serviceType: globalFilter?.serviceType?.value ?? "",
              toDate:
                globalFilter?.toDate === "Invalid date" ||
                globalFilter?.toDate === ""
                  ? ""
                  : globalFilter?.toDate,
              txnStatus: globalFilter?.txnStatus?.value ?? "",
              status: globalFilter?.status?.value ?? "",
              custRefNo: globalFilter?.custRefNo ?? "",
              transactionId: globalFilter?.transactionId ?? "",
              van: globalFilter?.van ?? "",
              bankUTR: globalFilter?.bankUTR ?? "",
              upi: globalFilter?.upi ?? "",
              mobileNumber: globalFilter?.mobileNumber ?? "",
              email: globalFilter?.email ?? ""
            })}
          />
        )}

        {customButtonRequired && customButtonRequired}
      </div>
    </div>
  );
}

export default TopHeaderComponent;
